import { Repo } from '../data/schema.js';

/**
 * 邻里：舍出去的，过些日子会回来。
 *
 * 这是「施食」那一环的收口——
 *   地里收的菜 -> 灶上做的饭 -> 端出去（aid / trustOfLocals / face）-> 灵感更容易撞上
 *   -> 撞出照 -> 照又让地里多收、灶上多做 …… 再回到那张桌上。
 *
 * 回礼按 flag 落账，一天只给一回（TIME_NEWDAY 会被发两次，别发两回礼）。
 */

const GIFTS = [
  { id: 'coin', lo: 6, hi: 12, say: (n) => `${n}文钱` },
  { id: 'veg', lo: 2, hi: 3, say: (n) => `${n}把青菜` },
  { id: 'herb', lo: 2, hi: 3, say: (n) => `${n}把草药` },
  { id: 'seed', lo: 2, hi: 2, say: (n) => `${n}包菜种` },
  { id: 'commonFish', lo: 1, hi: 1, say: () => '一条鱼' },
];

export const Neighbor = {
  /** 天亮时看一眼：昨日舍出去的，今日门口搁着什么（返回一句话给 HUD） */
  daily(db) {
    const w = Repo.getWorld(db);
    if (!Repo.getFlag(db, `gift:${w.day}`)) return [];
    if (Repo.getFlag(db, `giftDone:${w.day}`)) return [];
    Repo.setFlag(db, `giftDone:${w.day}`, true);

    const g = GIFTS[Math.floor(Math.random() * GIFTS.length)];
    const n = g.lo + Math.floor(Math.random() * (g.hi - g.lo + 1));
    Repo.addItem(db, g.id, n);
    const text = `门口搁着${g.say(n)}——昨日那碗饭，有人记着。`;
    Repo.log(db, text, 'good', w.day, 0);
    return [text];
  },
};
